module.exports = __webpack_public_path__ + "img/benefits.f5f981a8.svg";